import { Link, useParams } from "react-router-dom"
import { Button } from "react-bootstrap"

import CourseTable from "../../components/course-table/CourseTable"
import DefaultLayout from "../../components/layout/DefaultLayout"
import CourseForm from "../../components/course/CourseForm"

const Course = () => {
  const { add } = useParams()
  return (
    <DefaultLayout>
      {add ? (
        <div>
          <Link to="/course">
            <Button variant="warning" className="mb-3">
              Back
            </Button>
          </Link>
          <CourseForm />
        </div>
      ) : (
        <div>
          <Link to="/course/add">
            <Button variant="warning" className="mb-3">
              Add New Course
            </Button>
          </Link>
          <CourseTable />
        </div>
      )}
    </DefaultLayout>
  )
}

export default Course
